module.exports = __webpack_public_path__ + "static/pumps_industrial-aac79786332a2ca03f3ea5987ee1b199.png";